import React from 'react';
import { SmartphoneIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative py-20 md:py-32 overflow-hidden" data-id="element-554">
      <div className="absolute inset-0 w-full h-full" data-id="element-555">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-556">
          <source src="https://cdn.magicpatterns.com/uploads/sGn8wFmHmgDv3DQ8C8jCxr/extendedvid1.mp4" type="video/mp4" data-id="element-557" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-header/60 via-primary/50 to-primary/80" data-id="element-558"></div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-559">
        <div className="text-center" data-id="element-560">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-561">
            <SmartphoneIcon className="w-8 h-8 text-white" data-id="element-562" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-563">
            Mobile App Development for iOS & Android
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-564">
            We develop native mobile applications that deliver fast, reliable
            experiences on both iOS and Android platforms. Whether you need a
            customer-facing app, internal tool, or complex enterprise mobile
            solution, our team handles the full development lifecycle from
            design through App Store deployment.
          </p>
        </div>
      </div>
    </section>;
}